import React, { FC, useEffect } from 'react';

interface Props {
  readonly script: string;
}

const CookiePolicy: FC<Props> = ({ script }: Props) => {
  const loadCookiePolicyHtml = () => {
    if (window?.OneTrust?.initializeCookiePolicyHtml) {
      window.OneTrust.initializeCookiePolicyHtml();
    }
  };

  // OneTrust script in <head> loads the cookie policy on first load.
  // If first load happens on a page other than cookie policy, then
  // content on cookie policy remains empty when navigating to it.
  // This makes sure it always (re)loads after page has loaded and dom is ready.
  useEffect(() => {
    if (!(document?.readyState === 'complete')) {
      window.addEventListener('load', () => {
        loadCookiePolicyHtml();
      });
    } else {
      loadCookiePolicyHtml();
    }
  }, []);

  return (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: script }}
        className="py-component-spacing-mobile lg:py-component-spacing-content mx-auto w-full md:w-10/12 lg:w-8/12"
      />
    </>
  );
};

export default CookiePolicy;
